export default __webpack_public_path__ + "static/media/AGSML.f719c426.png";